import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class SituationTestAttribute extends CypressAttribute {
  static buttons: Record<string, string> = {
    SITUATION_TYPE_BUTTON: 'SituationTestAttribute:buttons:SITUATION_TYPE_BUTTON'
  };

  static view: Record<string, string> = {
    SITUATIONS: 'SituationTestAttribute:buttons:SITUATIONS'
  };
}
